import styled from "styled-components";

export const ConstructionTitle = styled.div`
    font-size: 4rem;
    font-weight: 700;
    font-family: 'lyon-display-web';
    text-align: center;
    padding-top: 15px;
    padding-bottom: 15px;
    max-width: calc(1200px - (50px * 2));
    margin: 0 auto;
`